module.exports = __webpack_public_path__ + "img/stop_circle.67509d2a.svg";